<mat-radio-group class="mt-8" class="flex flex-col" [(ngModel)]="option">
  <mat-radio-button
    class="ml-8 mt-3"
    *ngFor="let item of options"
    [value]="item"
  >
    {{item.text}}
  </mat-radio-button>
</mat-radio-group>
